import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;

	@media ${Breakpoints.mobile && Breakpoints.tablet} {
		display: block;
		padding: 0 var(--padding-2);
	}
`;
export const LeftContainer = styled.div`
	width: 70%;

	@media ${Breakpoints.mobile && Breakpoints.tablet} {
		width: 100%;
		margin: 0;
	}
`;

export const LogoWrapper = styled.div`
	display: flex;
	& > * {
		margin-top: var(--margin-2);
		margin-right: var(--margin-2);

		body[dir='rtl'] & {
			margin-right: unset;
			margin-left: var(--margin-2);
		}
	}
`;

export const Logo = styled(Image)`
	object-fit: scale-down;
	border-radius: 4px;
`;

export const LogoPlaceholder = styled.div`
	display: inline-block;
	width: 4.5rem;
	height: 4.5rem;
	border-radius: 4px;
	margin-top: var(--margin-2);
	background-color: black;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	cursor: pointer;
	transition: 100ms all;
	margin-right: var(--margin-3);
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-3);
	}
	&:hover {
		background-color: var(--content-2);
	}
`;
export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 30%;
	margin: -1.5rem -1.5rem -1.5rem 1.5rem;
	body[dir='rtl'] & {
		margin: -1.5rem 1.5rem -1.5rem -1.5rem;
	}

	padding: var(--padding-5) var(--padding-4);
	background-color: var(--background-1);
	> div {
		margin-bottom: 1rem;
	}

	@media ${Breakpoints.mobile && Breakpoints.tablet} {
		width: 100%;
		margin: auto;
	}
`;
export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
`;
